<template>
    <div>
        <Form :label-width="100" :model="formData" class="clearfix" ref="baseform">
            <Col span="100">
                <FormItem :label="$t('global.common.channel', { defaultValue: '渠道' })" style="width:250px;">
                    <Select v-model="formData.channelFlag" filterable clearable :max-tag-count="2">
                        <Option v-html="item.label" v-for="item in accountsTarget" :value="item.value" :key="item.value">{{item.label}}</Option>
                    </Select>
                </FormItem>
            </Col>
            <Col span="100">
                <FormItem label="SellerSKU" style="width:330px;">
                    <Input v-model="formData.sellerSku"
                           :rows="5"
                           placeholder="支持输入多个，一行一个sellersku"
                           type="textarea" />
                </FormItem>
            </Col>

        </Form>
        <div class="text-right margin-top-10">
            <vButton theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.cancel', { defaultValue: '取消' })}}</vButton>
        </div>
    </div>
</template>

<script>
import {
 HttpSyncAsin
} from '@/service/products/channel'
import { mapState, mapGetters } from "vuex";
export default {
    props:[],
    data(){
        return {
            loading1:false,
            formData:{
                channelFlag:"",
                sellerSku:"",
            },
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
            }],
        }
    },
    created(){
        //this.getDetail()
    },
    computed:{
        ...mapGetters('diction',['getNewAccountList']),
        accountsTarget() {
            return this.getNewAccountList.map((item) => {
                // console.log(item)
                const bool = item.attach.status === 'inactive';
                return {
                    label: bool ? `<span style='text-decoration:line-through'>${item.label}</span>` : `${item.label}`,
                    value: item.value,
                    // disabled:bool

                }
            })
        }
    },
    methods:{
        submit(){
            // console.log(this.formList)
            // console.log(this.formData)
            if (this.formData.sellerSku !=null && this.formData.sellerSku != "") {
                if (!(this.formData.IN_sellerSku instanceof Array)) {
                    let INid = this.formData.sellerSku.replace(/\n/g, ",");
                    this.formData.sellerSku = INid.split(",");
                }
            }
            let data = {
                contextId:global.SYSID,
                sellerSku:this.formData.sellerSku,
                channelFlag:this.formData.channelFlag
            }

            HttpSyncAsin({
                ...data
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.cancel()
                this.$emit('on-update')
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>
